import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GridColumn } from '../../column/column.component';
import { GridRow } from '../../row/row.component';
import { GridViewBase } from '../grid-view-base.component';

@Component({
  selector: 'lepi-grid-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  standalone: true,
  imports: [GridRow, GridColumn, CommonModule],
})
export class GridTable extends GridViewBase {}
